(function () {
    // touch css class
    const el = document.createElement("div");
    el.setAttribute("ongesturestart", "return;");
    if (typeof el.ongesturestart == "function") {
        document.body.classList.add("touch");
    } else {
        document.body.classList.add("no-touch");
    }
})();